var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinAttachmentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 0.72 0.72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.584 0.167c-0.021 -0.022 -0.058 -0.024 -0.083 0.001l-0.243 0.243c-0.006 0.006 -0.006 0.014 0 0.021s0.014 0.006 0.021 0l0.201 -0.201a0.03 0.03 0 0 1 0.042 0.042l-0.201 0.201a0.073 0.073 0 0 1 -0.105 0 0.073 0.073 0 0 1 0 -0.105l0.243 -0.243c0.047 -0.047 0.123 -0.049 0.169 0 0.047 0.047 0.048 0.123 -0.001 0.168l-0.285 0.285c-0.066 0.066 -0.169 0.066 -0.234 0s-0.066 -0.169 0 -0.234l0.243 -0.243a0.03 0.03 0 0 1 0.042 0.042l-0.243 0.243c-0.042 0.042 -0.042 0.107 0 0.15s0.107 0.042 0.15 0l0.285 -0.285 0.001 -0.001c0.022 -0.021 0.024 -0.058 -0.001 -0.083z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAttachmentIcon);
export default __webpack_public_path__ + "static/media/pin-attachment-icon.7fc7c44918afa3f804c3e26ccd26db44.svg";
export { ForwardRef as ReactComponent };